module.exports = __webpack_public_path__ + "assets/img/main-loader.efc428e8.svg";